exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".help-me-decide h3{font-size:30px;font-weight:300}.help-me-decide svg.need-icons{border-radius:50%;background:#f2f2f2;padding:3px 5px;height:1.5em;width:1.5em;font-size:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Home/HelpMeDecide/HelpMeDecide.scss
// module id = 7446
// module chunks = 13